const CLOSED_ORDER_STATUSES = new Set(["completed", "cancelled"]);
const DATE_KEY_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;
const TIME_PATTERN = /^(\d{2}):(\d{2})$/;

function normalizeOrderLifecycleStatus(order) {
  const status = String(order?.status || "").toLowerCase();
  return CLOSED_ORDER_STATUSES.has(status) ? status : "";
}

function parseLocalDateParts(dateKey) {
  const match = String(dateKey || "").match(DATE_KEY_PATTERN);
  if (!match) return null;
  const [, year, month, day] = match;
  return {
    year: Number(year),
    month: Number(month),
    day: Number(day),
  };
}

function parseLocalDate(dateKey) {
  const parts = parseLocalDateParts(dateKey);
  if (!parts) return null;
  return new Date(parts.year, parts.month - 1, parts.day);
}

function parseLocalDateTime(dateKey, timeValue) {
  const parts = parseLocalDateParts(dateKey);
  const timeMatch = String(timeValue || "").match(TIME_PATTERN);
  if (!parts || !timeMatch) return null;
  const [, hours, minutes] = timeMatch;
  const date = new Date(parts.year, parts.month - 1, parts.day, Number(hours), Number(minutes));
  return Number.isNaN(date.getTime()) ? null : date;
}

function startOfLocalDay(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

function endOfLocalDay(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 999);
}

export function getAdminOrderTimeCategory(order, now = new Date()) {
  const lifecycleStatus = normalizeOrderLifecycleStatus(order);
  if (lifecycleStatus) return lifecycleStatus;

  const departureDateTime = parseLocalDateTime(order?.departure_date, order?.pickup_time);
  if (departureDateTime) {
    const hoursUntilDeparture = (departureDateTime - now) / (1000 * 60 * 60);
    if (hoursUntilDeparture < -24) return "completed";
    if (hoursUntilDeparture <= 48) return "in_progress";
    return "not_started";
  }

  const departureDate = parseLocalDate(order?.departure_date);
  if (!departureDate) return "not_started";

  if (departureDate < startOfLocalDay(now)) return "completed";

  const hoursUntilServiceDayEnds = (endOfLocalDay(departureDate) - now) / (1000 * 60 * 60);
  if (hoursUntilServiceDayEnds <= 48) return "in_progress";
  return "not_started";
}
